import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  NavItem,
  Nav,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  TabContent,
  TabPane,
  Badge,
  CardBody,
  Col,
  Card,
  CustomInput,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../helpers/IntlMessages';
import Select from 'react-select';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import {
  API_Firecrawl,
  API_External_Source_Content,
  API_Ingetration_Channels,
  API_External_Source,
} from '../../../../../constants/APIs';
import moment from 'moment';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import classnames from 'classnames';
function ExternalSourcesForm({
  sourceDetails,
  submit,
  visible,
  propertyId,
  label,
  email,
  toggle,
  sabreIntegration,
}) {
  const [tags, setTags] = useState([]);
  const [activeTab, setActiveTab] = useState('WebPage');
  const [selectedTags, setSelectedTags] = useState([]);
  const [logList, setLogList] = useState([]);
  const [isvisible, setIsVisible] = useState(false);
  const [previewModel, setPreviewModel] = useState('');
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [sourceData, setSourceData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId,
    createdBy: 'Admin',
    sourceStatus: 'Active',
    sourceType: 'WebPage',
    name: '',
    frequency: 'Weekly',
    webPages: [],
    faqList: [],
    ignoreSettings: {
      isIgnoreFromStart: false,
      isIgnoreFromEnd: false,
      ignoreFromStart: '',
      ignoreFromEnd: '',
    },
    synXisConfiguration: {
      guestRooms: false,
      generalText: false,
      propertyDescription: false,
      policies: false,
      contactInfo: false,
      locationInfo: false,
    },
    enableFAQ: false,
    email: email,
    excludeTags: [],
  });
  const [previewDetails, setPreviewDetails] = useState({
    url: '',
    text: '',
  });
  const [showTagPopup, setShowTagPopup] = useState(false);

  // const handleSynXisConfiguration = (e) => {
  //   let configuration = { ...sourceData.synXisConfiguration };
  //   configuration[e.target.name] = e.target.checked;
  //   setSourceData({ ...sourceData, synXisConfiguration: configuration });
  // };

  useEffect(() => {
    const callApi = async () => {
      if (sourceDetails?.id) {
        await AxiosAPI({
          method: 'get',
          url: `${API_External_Source}/${sourceDetails?.id}`,
        }).then(async (res) => {
          if (res.data?.faqList === null) res.data.faqList = [];

          if (
            res.data?.excludeTags && res.data.excludeTags.length > 0) {
            const formattedTags = res.data.excludeTags.map((tag) => ({
              label: tag,
              value: tag,
            }));
            setExcludeTagOptions((prev) => {
              const merged = [...prev];
              formattedTags.forEach((tag) => {
                if (!merged.find((m) => m.value === tag.value)) {
                  merged.push(tag);
                }
              });
              return merged;
            });
            setSelectedExcludeTags(formattedTags);
          }
          if (res.data?.webPages !== undefined && res.data?.webPages.length > 0) {
            const lstSubPages = res.data?.webPages.map(async (p) => {
              let body = [p.link];
              try {
                if (p.includeSubpages === true)
                  return AxiosPublicAPI({
                    method: 'post',
                    url: `${process.env.REACT_APP_CHAT_API}/website-suburls`,
                    data: body,
                  })
                    .then((json) => {
                      p.subPages = json.data.map((m) => ({
                        label: m,
                        value: m,
                        key: m,
                      }));
                      p.subPages.push({
                        label: 'All',
                        value: 'All',
                        key: 'All'
                      });
                      if (
                        p?.selectedPages &&
                        p?.selectedPages.length > 0) {
                        p.selectedPages = p?.selectedPages.map((m) => ({
                          label: m,
                          value: m,
                          key: m,
                        }));
                      } else {
                        p.selectedPages = [];
                      }
                    })
                    .catch((err) => { });
              } catch { }
            });
            Promise.all(lstSubPages).then(() => {
              setSourceData(res.data);
            });
          } else {
            setSourceData(res.data);
          }
        });
      }
    };
    callApi();
  }, [propertyId]);

  const handleSave = () => {
    const objSource = JSON.parse(JSON.stringify(sourceData));
    objSource.webPages = objSource.webPages.map((m) => ({
      ...m,
      selectedPages: m?.selectedPages
        ?.filter(f => f != null)
        .map((s) => (typeof s === 'object' ? s.value : s))
    }));
    objSource.excludeTags = selectedExcludeTags.map((tag) => tag.value);
    submit(objSource);
  };
  const handleAddWebPages = () => {
    let lst = [...sourceData.webPages];
    lst.push({
      link: '',
      includeSubpages: false,
      selectedPages: [{ label: 'All', value: 'All', key: 'All' }],
      subPages: [],
    });
    setSourceData({ ...sourceData, webPages: lst });
  };

  const handleAddFAQ = () => {
    let lst = [...sourceData.faqList];
    lst.push('');
    setSourceData({ ...sourceData, faqList: lst });
  };

  const handlePreviewToggle = () => {
    setPreviewModel(!previewModel);
    setPreviewDetails({ url: '', text: '' });
  };

  const handleRemoveWebPages = (val) => {
    let lst = [...sourceData.webPages];
    lst = lst.filter((f, index) => index !== val);
    setSourceData({ ...sourceData, webPages: lst });
  };

  const handleRemoveFilters = (index, subIndex) => {
    let lst = [...sourceData.webPages];
    lst[index].filters = lst[index]?.filters.filter((f, i) => i !== subIndex);
    // console.log(lst, 202);
    setSourceData({ ...sourceData, webPages: lst });
  };

  const handleAddFilters = (index, subIndex) => {
    let lst = [...sourceData.webPages];
    lst[index]?.filters.push({ type: '', search: '' });
    // console.log(lst, 208);
    setSourceData({ ...sourceData, webPages: lst });
  };

  const handleRemoveFAQList = (val) => {
    let lst = [...sourceData.faqList];
    lst = lst.filter((f, index) => index !== val);
    setSourceData({ ...sourceData, faqList: lst });
  };

  const handleFetchPageContent = async (url) => {
    try {
      setIsPreviewLoading(true);

      const res = await AxiosAPI({
        method: 'post',
        url: `${API_Firecrawl}/scrape`,
        data: {
          url,
        },
      });

      const regexForStripHTML = /<([^</> ]+)[^<>]*?>[^<>]*?<\/\1> */gi;
      const text = 'OCEP <sup>&reg;</sup> water product';
      const stripContent = res.data.data.markdown.replace(/(<([^>]+)>)/gi, '').replace(/\r\n/g, '\n').replace(/\n\s*\n+/g, '\n\n').trim();
      setPreviewDetails({ url: url, text: stripContent });
      setPreviewModel(!previewModel);
    } catch (err) {
      console.log(err);
      NotificationManager.error('Failed to fetch preview content');
    } finally {
      setIsPreviewLoading(false);
    }
  };

  const handleToggle = () => {
    setIsVisible(!isvisible);
  };

  const handleChange = (e) => {
    setSourceData({ ...sourceData, [e.target.name]: e.target.value });
  };

  const handleFilterChange = (e, index, subIndex) => {
    let lst = [...sourceData.webPages];
    lst[index].filters[subIndex][e.target.name] = e.target.value;
    setSourceData({ ...sourceData, webPages: lst });
  };

  const handleChecked = (e) => {
    setSourceData({ ...sourceData, [e.target.name]: e.target.checked });
  };

  // const toggleAppMenu = (tab) => {
  //   setActiveTab(tab);
  //   setSourceData({
  //     ...sourceData,
  //     sourceType: tab === 'WebPage' ? 'WebPage' : 'SynXis',
  //   });
  // };

  const handleFaqListChange = (e, index) => {
    let lst = [...sourceData.faqList];
    lst[index] = e.target.value;
    setSourceData({ ...sourceData, faqList: lst });
  };

  const handleWebPageChange = (e, index) => {
    let lst = [...sourceData.webPages];
    lst[index][e.target.name] = e.target.value;
    setSourceData({ ...sourceData, webPages: lst });
  };

  // const handleWebPageChecked  = (e, index) => {  
  //   let lst = [...sourceData.webPages];
  //   lst[index][e.target.name] = e.target.checked;
  //   setSourceData({ ...sourceData, webPages: lst });
  //   fetchSubPages(lst[index].link, index);
  // };

  const handleWebPageChecked = (name, checked, index) => {
    let lst = [...sourceData.webPages];
    lst[index][name] = checked;
    setSourceData({ ...sourceData, webPages: lst });
    fetchSubPages(lst[index].link, index);
  };

  const fetchSubPages = async (url, index) => {
    setIsPreviewLoading(true);

    try {
      let body = [url];

      const res = await AxiosPublicAPI({
        method: 'post',
        url: `${process.env.REACT_APP_CHAT_API}/website-suburls`,
        data: body,
      });

      if (res.data?.length > 0) {
        let links = [];
        let subpage = '';
        if (url.includes('html') || url.includes('aspx')) {
          subpage = url.substring(0, url.lastIndexOf('/'));
          links = res.data.filter(
            (t) => t.startsWith(url) || t.startsWith(subpage)
          );
        } else {
          var newURL = new URL(url);
          subpage = newURL.pathname;
          links = res.data.filter((t) => t.includes(subpage));
        }
        let lst = [...sourceData.webPages];
        lst[index]?.subPages.push({ label: 'All', value: 'All', key: 'All' });
        links.map((m) =>
          lst[index]?.subPages.push({ label: m, value: m, key: m })
        );
        lst[index].filters = [];
        setSourceData({ ...sourceData, webPages: lst });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsPreviewLoading(false);
    }
  };

  const handleSelectedPages = (selectedOptions, index) => {
    let lst = [...sourceData.webPages];
    if (selectedOptions.filter((f) => f.value === 'All').length > 0)
      lst[index].selectedPages = [{ label: 'All', value: 'All', key: 'All' }];
    else
      lst[index].selectedPages = selectedOptions.filter(
        (f) => f.value !== 'All'
      );
    setSourceData({ ...sourceData, webPages: lst });
  };

  const handleIgnoreSettings = (e) => {
    let setting = { ...sourceData.ignoreSettings };
    setting[e.target.name] =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setSourceData({ ...sourceData, ignoreSettings: setting });
  };

  const [excludeTagOptions, setExcludeTagOptions] = useState([
    { label: '+ Add New', value: 'Add own tag' },
    { label: 'img', value: 'img' },
    { label: 'svg', value: 'svg' },
    { label: 'picture', value: 'picture' },
    { label: 'figure', value: 'figure' },
    { label: 'header', value: 'header' },
    { label: 'footer', value: 'footer' },
    { label: 'nav', value: 'nav' },
    { label: 'aside', value: 'aside' },
  ]);

  const [selectedExcludeTags, setSelectedExcludeTags] = useState([
    { label: 'img', value: 'img' },
    { label: 'svg', value: 'svg' },
    { label: 'picture', value: 'picture' },
    { label: 'figure', value: 'figure' },
    { label: 'header', value: 'header' },
    { label: 'footer', value: 'footer' },
    { label: 'nav', value: 'nav' },
    { label: 'aside', value: 'aside' },
  ]);
  const [customTag, setCustomTag] = useState('');
  const handleAddCustomTag = () => {
    const trimmedTag = customTag.trim().toLowerCase();
    if (!trimmedTag) return;
    const alreadyExists = excludeTagOptions.some((tag) => tag.value === trimmedTag);
    if (!alreadyExists) {
      const newOption = { label: trimmedTag, value: trimmedTag };
      setExcludeTagOptions([...excludeTagOptions, newOption]);
      setSelectedExcludeTags([...selectedExcludeTags, newOption]);
    }
    setCustomTag('');
    setShowTagPopup(false);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
        <ModalHeader toggle={toggle}>{label}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Row>
              <Colxx sm={4} className="mb-3">
                <Label>
                  <IntlMessages id="dashboards.title" />{' '}
                  <span style={{ color: 'red' }}> *</span>
                </Label>
                <Input
                  value={sourceData.name}
                  name="name"
                  onChange={handleChange}
                ></Input>
              </Colxx>
              <Colxx sm={4} className="mb-3">
                <Label>
                  <IntlMessages id="pages.status" />
                  <span style={{ color: 'red' }}> *</span>
                </Label>
                <Input
                  type="select"
                  value={sourceData.status}
                  name="status"
                  onChange={handleChange}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Input>
              </Colxx>
              <Colxx sm={4} className="mb-3">
                <Label>
                  <IntlMessages id="dashboards.frequency" />{' '}
                  <span style={{ color: 'red' }}> *</span>
                </Label>
                <Input
                  type="select"
                  value={sourceData.frequency}
                  name="frequency"
                  onChange={handleChange}
                >
                  {/* <option value="Daily">Daily</option> */}
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Manually">Manually</option>
                </Input>
              </Colxx>
            </Row>
            <Row>
              <Colxx sm={12}>
                <FormGroup className="m-0">
                  <div className="mb-2">
                    {sourceData?.webPages?.length > 0 && (
                      <Row>
                        <Colxx sm={6} className="mb-1">
                          <Label for="webPages">
                            <IntlMessages id="dashboards.web-pages" />
                            <span style={{ color: 'red' }}> *</span>
                          </Label>
                        </Colxx>
                        {/* <Colxx sm={2} className="mb-1">
                        <Label for="webPages">
                          <IntlMessages id="dashboards.includeSubpages" />
                        </Label>
                      </Colxx> */}
                      </Row>
                    )}
                    {sourceData?.webPages &&
                      sourceData.webPages.map((m, index) => (
                        <div className="py-2" key={index}>
                          <Row>
                            <Colxx sm={10} className="mb-2 pr-0">
                              <div style={{ display: 'flex', border: '1px solid #d7d7d7', borderRadius: '4px', overflow: 'hidden' }}>
                                <Input
                                  value={m.link}
                                  name="link"
                                  onChange={(e) => handleWebPageChange(e, index)}
                                  style={{ border: 'none', outline: 'none', boxShadow: 'none' }}
                                />
                                <button
                                  onClick={() => handleFetchPageContent(m.link)}
                                  style={{
                                    border: 'none',
                                    borderLeft: '1px solid #d7d7d7',
                                    background: 'transparent',
                                    padding: '6px 14px',
                                    fontSize: '13px',
                                    color: '#555',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Preview
                                </button>
                              </div>
                            </Colxx>
                            {/* <Colxx sm={2} className="mb-2">
                              <CustomInput
                                type="checkbox"
                                checked={
                                  m.includeSubpages === true ? true : false
                                }
                                name="includeSubpages"
                                onChange={(e) => handleWebPageChecked(e, index)}
                              />
                            </Colxx> */}
                            {/* {m !== '' && (
                              <Colxx sm={2} className="mb-2">
                                <Button
                                  outline
                                  size="xs"
                                  color="primary"
                                  onClick={() => handleFetchPageContent(m.link)}
                                >
                                  Preview
                                </Button>
                              </Colxx>
                            )} */}
                            <Colxx sm={1.5} className="text-right mt-1 pl-2">
                              <Button
                                outline
                                size="xs"
                                color="primary"
                                className="px-2"
                                onClick={() => handleWebPageChecked("includeSubpages", true, index)}
                              >
                                Fetch Subpages
                              </Button>
                            </Colxx>
                            <Colxx sm={0.5} className="text-right mt-1 pl-2">
                              <Button
                                outline
                                size="xs"
                                color="danger"
                                className="px-2"
                                onClick={() => handleRemoveWebPages(index)}
                              >
                                X
                              </Button>
                            </Colxx>
                          </Row>
                          {m?.subPages !== undefined &&
                            m?.subPages.length > 0 && (
                              <>
                                <Row>
                                  <Colxx sm={12} className="mb-2">
                                    <Select
                                      components={{ Input: CustomSelectInput }}
                                      className="react-select"
                                      isMulti={true}
                                      classNamePrefix="react-select"
                                      name="form-field-name"
                                      options={m?.subPages.map((x, i) => ({
                                        label: x.label,
                                        value: x.label,
                                        key: i,
                                      }))}
                                      value={m?.selectedPages}
                                      onChange={(e) => handleSelectedPages(e, index)}
                                    />
                                  </Colxx>
                                </Row>
                                {m?.selectedPages && m.selectedPages
                                  .filter((p) => p.value !== 'All')
                                  .map((page, pageIndex) => (
                                    <Row key={pageIndex} className="mb-1">
                                      <Colxx sm={12}>
                                        <div style={{ display: 'flex', border: '1px solid #d7d7d7', borderRadius: '4px', overflow: 'hidden' }}>
                                          <input
                                            value={page.value}
                                            readOnly
                                            style={{
                                              flex: 1,
                                              border: 'none',
                                              outline: 'none',
                                              padding: '6px 10px',
                                              fontSize: '13px',
                                              background: 'transparent',
                                            }}
                                          />
                                          <button
                                            onClick={() => handleFetchPageContent(page.value)}
                                            style={{
                                              border: 'none',
                                              borderLeft: '1px solid #d7d7d7',
                                              background: 'transparent',
                                              padding: '6px 14px',
                                              fontSize: '13px',
                                              color: '#555',
                                              cursor: 'pointer',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            Preview
                                          </button>
                                        </div>
                                      </Colxx>
                                    </Row>
                                  ))
                                }
                              </>
                            )}
                          {/* {m?.subPages !== undefined &&
                            m?.subPages.length > 1 && (
                              <Fragment>
                                {' '}
                                {m?.filters &&
                                  m?.filters.length > 0 &&
                                  m?.filters.map((f, secondIndex) => (
                                    <Row className="mb-1">
                                      <Colxx sm={4} className="mb-2">
                                        <Input
                                          type="select"
                                          value={f?.type}
                                          name="type"
                                          onChange={(e) =>
                                            handleFilterChange(
                                              e,
                                              index,
                                              secondIndex
                                            )
                                          }
                                        >
                                          <option value="">Please Select</option>
                                          <option value="StartsWith">
                                            StartsWith
                                          </option>
                                          <option value="Includes">
                                            Includes
                                          </option>
                                        </Input>
                                      </Colxx>
                                      <Colxx sm={6} className="mb-2">
                                        {' '}
                                        <Input
                                          value={f?.search}
                                          name="search"
                                          onChange={(e) =>
                                            handleFilterChange(
                                              e,
                                              index,
                                              secondIndex
                                            )
                                          }
                                        ></Input>
                                      </Colxx>
                                      <Colxx sm={2} className="mb-2">
                                        <Button
                                          outline
                                          size="xs"
                                          color="danger"
                                          onClick={() =>
                                            handleRemoveFilters(
                                              index,
                                              secondIndex
                                            )
                                          }
                                        >
                                          X
                                        </Button>
                                      </Colxx>
                                    </Row>
                                  ))}{' '}
                                <Row className="mb-1">
                                  <Colxx sm={6} className="mb-2">
                                    <Button
                                      outline
                                      size="xs"
                                      color="primary"
                                      onClick={() => handleAddFilters(index)}
                                    >
                                      + Filters
                                    </Button>
                                  </Colxx>
                                </Row>
                              </Fragment>
                            )} */}
                          {/* <Colxx sm={2} className="text-right">
                            <Button
                              outline
                              size="xs"
                              color="danger"
                              onClick={() => handleRemoveWebPages(index)}
                            >
                              X
                            </Button>
                          </Colxx> */}
                        </div>
                      ))}
                  </div>
                </FormGroup>
              </Colxx>

              {isPreviewLoading && (
                <div className="loading-overlay">
                  <div className="loading "></div>
                </div>
              )}
              <Colxx sm={6}>
                <Button
                  outline
                  size="xs"
                  color="primary"
                  onClick={() => handleAddWebPages()}
                  className='mb-4'
                >
                  + <IntlMessages id="dashboards.webpage" />
                </Button>
              </Colxx>
            </Row>
            <Separator className="mb-3" />
            <Row>
              <Colxx xxs="12">
                <div className="d-flex justify-content-between align-items-center">
                  <h6>Exclude Tags</h6>
                </div>
                <div className="mb-2">
                  Tags, classes and ids to remove from the page.
                  By default, these tags are excluded, add more if needed.
                </div>
                <Select
                  isMulti
                  options={excludeTagOptions}
                  value={selectedExcludeTags}
                  onChange={(selected) => {
                    if (selected && selected.find((s) => s.value === 'Add own tag')) {
                      setShowTagPopup(true);
                    } else {
                      setSelectedExcludeTags(selected || []);
                    }
                  }}
                  className="react-select"
                  classNamePrefix="react-select"
                  placeholder="Select tags..."
                />
              </Colxx>
            </Row>
            {/*
            <Separator className="mb-3" />
          <Row>
              <Colxx sm={10} className="mb-1 ">
                <FormGroup className="d-flex">

                  <CustomInput
                    type="checkbox"
                    checked={sourceData?.enableFAQ}
                    name="enableFAQ"
                    onChange={handleChecked}
                  />
                  <span> <IntlMessages id='dashboards.enableFaqs' /></span>

                </FormGroup>
                <p><IntlMessages id='dashboards.faqsDescription' />.</p>
              </Colxx>
            </Row> */}
            {/* {sourceData?.enableFAQ && (
              <Row>
                <Colxx sm={12} className="mb-1">
                  <FormGroup>
                    <Label for="webPages">
                      <IntlMessages id="dashboards.faq" />
                      <span style={{ color: 'red' }}> *</span>
                    </Label>
                    {sourceData?.faqList &&
                      sourceData.faqList.map((m, index) => (
                        <Row className="mb-1">
                          <Colxx sm={10} className="mb-2">
                            <Input
                              value={m}
                              name="name"
                              onChange={(e) => handleFaqListChange(e, index)}
                            ></Input>
                          </Colxx>
                          <Colxx sm={2} className="mb-2">
                            <Button
                              outline
                              size="xs"
                              color="danger"
                              onClick={() => handleRemoveFAQList(index)}
                            >
                              X
                            </Button>
                          </Colxx>
                        </Row>
                      ))}
                  </FormGroup>
                </Colxx>
                <Colxx sm={6} className="mb-2">
                  <Button
                    outline
                    size="xs"
                    color="primary"
                    onClick={() => handleAddFAQ()}
                  >
                    + <IntlMessages id="dashboards.faq" />
                  </Button>
                </Colxx>
              </Row>
            )} */}
            {/* <Colxx sm={12} className="mb-2">
            <h6>Remove Header and Footer Content</h6>
            </Colxx>
            <Row className='my-1'>
              <Colxx sm={12} className="mb-1">
                <CustomInput
                  type="checkbox"
                  label="Ignore page content before this text in the source file"
                  checked={
                    sourceData?.ignoreSettings?.isIgnoreFromStart === true
                      ? true
                      : false
                  }
                  name="isIgnoreFromStart"
                  onChange={handleIgnoreSettings}
                />
              </Colxx>
            </Row>
            <Row>
              {sourceData?.ignoreSettings?.isIgnoreFromStart === true && (
                <Colxx sm={5} className="mb-1">
                  <Input
                    value={sourceData?.ignoreSettings?.ignoreFromStart || ''}
                    name="ignoreFromStart"
                    onChange={handleIgnoreSettings}
                  ></Input>
                </Colxx>
              )}
            </Row>
            <Row>
              <Colxx sm={12} className="mb-1">
                <CustomInput
                  type="checkbox"
                  label="Ignore page content after this text in the source file"
                  checked={
                    sourceData?.ignoreSettings?.isIgnoreFromEnd === true
                      ? true
                      : false
                  }
                  name="isIgnoreFromEnd"
                  onChange={handleIgnoreSettings}
                />
              </Colxx>
            </Row>
            <Row>
              {sourceData?.ignoreSettings?.isIgnoreFromEnd === true && (
                <Colxx sm={5} className="mb-1">
                  <Input
                    value={sourceData?.ignoreSettings?.ignoreFromEnd || ''}
                    name="ignoreFromEnd"
                    onChange={handleIgnoreSettings}
                  ></Input>
                </Colxx>
              )}
            </Row> */}
          </Fragment>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="xs" onClick={handleSave}>Save Schedule</Button>
          <Button color="secondary" size="xs" onClick={toggle}>Back</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showTagPopup} style={{ marginTop: '120px' }} toggle={() => { setShowTagPopup(false); setCustomTag(''); }} size="md">
        <ModalHeader toggle={() => { setShowTagPopup(false); setCustomTag(''); }}>
          Add Custom Tag
        </ModalHeader>
        <ModalBody>
          <Label>Tag Name</Label>
          <Input
            value={customTag}
            placeholder="e.g. div, .my-class, #my-id"
            onChange={(e) => setCustomTag(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleAddCustomTag();
              }
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="xs" onClick={handleAddCustomTag}>
            Add Tag
          </Button>
          <Button color="secondary" size="xs" onClick={() => { setShowTagPopup(false); setCustomTag(''); }}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={previewModel} toggle={handlePreviewToggle} style={{ maxWidth: '800px', marginTop: '120px' }}>
        <ModalHeader toggle={handlePreviewToggle}>
          {previewDetails?.url}
        </ModalHeader>
        <ModalBody>
          <Input
            type="textarea"
            style={{ height: '250px' }}
            value={previewDetails?.text}
          ></Input>
        </ModalBody>
        <ModalFooter>
          <Button
            className="ml-2"
            color="dark"
            outline
            size="xs"
            onClick={handlePreviewToggle}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(ExternalSourcesForm));
